<template>
  <v-page page="Admin Panel" :breadcrumb="breadcrumb">
    <v-form>
      <v-container ma-0 px-3 pt-0 pb-0>
        <v-layout text-xs-center>
          <v-flex mb-0 xs12 mx-2>
            <!-- Header -->
            <v-layout justify-center row align-center>
              <v-flex pa-0>
                <div pa-0>
                  <v-layout justify-start row align-center mt-4 mb-4>
                    <v-flex align-center>
                      <div
                        class="text-xs-left align-center"
                        style="font-size: 20px; font-weight: 600;"
                      >
                        Administration Panel
                      </div>
                    </v-flex>
                    <v-flex class="align-center xs3">
                      <!-- <v-text-field
                        v-model="search"
                        append-icon="fa-search"
                        label="Search"
                        single-line
                        hide-details
                        class="align-center mt-0 pt-0"
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                  <!--------------End of Header ---------------->

                  <!------------- Accordion -------------------->
                  <v-layout>
                    <v-expansion-panel class="elevation-3" v-if="hasUserAdminRole">
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div class="subheading" style="font-weight: 500;">
                            Users
                          </div>
                        </template>
                        <userManagement></userManagement>
                      </v-expansion-panel-content>
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div class="subheading" style="font-weight: 500;">
                            Reports
                          </div>
                        </template>
                        <reportsManagement></reportsManagement>
                      </v-expansion-panel-content>
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div class="subheading" style="font-weight: 500;">
                            Dashboards
                          </div>
                        </template>
                        <dashboardsManagement></dashboardsManagement>
                      </v-expansion-panel-content>
                      <v-expansion-panel-content :lazy="true" v-if="hasBOSS40AdminRole">
                        <template v-slot:header>
                          <div class="subheading" style="font-weight: 500;">
                            BOSS40
                          </div>
                        </template>
                        <boss40Management></boss40Management>
                      </v-expansion-panel-content>
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div class="subheading" style="font-weight: 500;">
                            Release Notes
                          </div>
                        </template>
                        <releaseNotesManagement></releaseNotesManagement>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-layout>
                  <!-- end Accordion -->
                </div>
              </v-flex>
            </v-layout>

            <!-- end -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import userManagement from "./UserManagement.vue";
import reportsManagement from "./ReportsManagement.vue"
import boss40Management from "./BOSS40Management.vue"
import releaseNotesManagement from "./ReleaseNotesManagement.vue"
import dashboardsManagement from "./DashboardsManagement.vue"
// import businessRulesManagement from "./BusinessRulesManagement.vue"
import "@/assets/css/main.css"

export default {
  name: "AdminPanel",
  components: {
    VPage,
    userManagement,
    reportsManagement,
    boss40Management,
    releaseNotesManagement,
    dashboardsManagement
    // businessRulesManagement
  },

  data: () => ({
    dialog: false,
    search: "",
    loading: true,
    hasUserAdminRole: false,
    hasBOSS40AdminRole:false,

    rowsPerPageItems: [
      30,
      45,
      60,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: false
    },

    breadcrumb: [
      {
        text: "Admin",
        disabled: false,
        href: "#/admin"
      },
      {
        text: "Panel",
        disabled: true,
        href: "#/admin"
      }
    ]
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getAdminRoles();
      this.getBOSS40AdminRoles();
    },

    getAdminRoles(){
        axios({
            method: 'post',
            url: '/api/User/HasRole/',
            data: {"roleName":"UserAdmin"}
          })
          .then(response => {
            // console.log(response.data.hasRole)
            this.hasUserAdminRole = response.data.hasRole;
          })
          .catch(error =>{
            console.log(error);
          });
    },
     getBOSS40AdminRoles(){
        axios({
            method: 'post',
            url: '/api/User/HasRole/',
            data: {"roleName":"BOSS40Admin"}
          })
          .then(response => {
            // console.log(response.data.hasRole)
            this.hasBOSS40AdminRole = response.data.hasRole;
          })
          .catch(error =>{
            console.log(error);
          });
    },
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 20px;
  font-size: 12px;
}
table.v-table tbody th {
  background-color: #4caf50;
}
table.v-table tbody tr:not(:last-child) {
  height: 20px;
  font-size: 12px;
}

.v-toolbar__content {
  padding: 0px;
}
</style>
